import { AgentLinkButton } from "@/pages/agent/components/agent-link-button";
import {
  AgentMetaCard,
  AgentMetaMonospace,
  type AgentMetaItem,
} from "@/pages/agent/components/agent-meta-card";
import { formatAgentDate } from "@/pages/agent/utils/agent-date.utils";
import { formatStatusLabel } from "@/pages/agent/utils/agent-status.utils";
import type { TaskDetailViewModel } from "@/pages/agent/task/agent-task-page.utils";

export const AgentTaskMetaCard = ({
  taskDetail,
  onOpenProject,
}: {
  taskDetail: TaskDetailViewModel;
  onOpenProject: ({ projectId }: { projectId: string }) => void;
}) => {
  const { task, project, projectTitle, nextFollowUp, followUpCount } = taskDetail;

  const items: AgentMetaItem[] = [
    { label: "Status", value: formatStatusLabel({ status: task.status }) },
    {
      label: "Project",
      value: project ? (
        <AgentLinkButton
          truncate
          onClick={() => {
            onOpenProject({ projectId: project.id });
          }}
        >
          {projectTitle}
        </AgentLinkButton>
      ) : (
        projectTitle
      ),
    },
    {
      label: "Due Date",
      value: task.dueAt ? formatAgentDate({ value: task.dueAt, includeTime: true }) : "No due date",
    },
    {
      label: "Created Date",
      value: formatAgentDate({ value: task.createdAt, includeTime: true }),
    },
    {
      label: "Last Update",
      value: formatAgentDate({ value: task.updatedAt, includeTime: true }),
    },
    {
      label: "Next Follow-up",
      value: nextFollowUp
        ? formatAgentDate({
            value: nextFollowUp.scheduledFor ?? nextFollowUp.dueAt,
            includeTime: true,
          })
        : "None scheduled",
    },
    { label: "Follow-ups", value: String(followUpCount) },
    { label: "Task ID", value: <AgentMetaMonospace>{task.id}</AgentMetaMonospace> },
  ];

  return <AgentMetaCard items={items} />;
};
